<div [formGroup]="formGroup">
  @if (arrayName) {
    <!-- 複数のフォームの場合 -->
    <div [formArrayName]="arrayName">
      <mat-form-field [class]="formWidthClass">
        <mat-label
          >{{ labelMessage }}
          @if (toolTipMessage) {
            <mat-icon
              [matTooltip]="toolTipMessage"
              matTooltipClass="tw-whitespace-pre-line matp-medium-tooltip"
              class="tw-ml-1"
            >
              info
            </mat-icon>
          }
        </mat-label>
        <mtx-datetimepicker
          #startDatetimePicker
          [type]="type"
          mode="portrait"
          timeInput
        ></mtx-datetimepicker>
        <input
          [mtxDatetimepicker]="startDatetimePicker"
          [formControlName]="controlName"
          [placeholder]="placeholder"
          matInput
        />
        <mtx-datetimepicker-toggle
          [for]="startDatetimePicker"
          matSuffix
        ></mtx-datetimepicker-toggle>
      </mat-form-field>
    </div>
  } @else {
    <!-- 単一のフォームの場合 -->
    <mat-form-field [class]="formWidthClass">
      <mat-label
        >{{ labelMessage }}
        @if (toolTipMessage) {
          <mat-icon
            [matTooltip]="toolTipMessage"
            matTooltipClass="tw-whitespace-pre-line matp-medium-tooltip"
            class="tw-ml-1"
          >
            info
          </mat-icon>
        }
      </mat-label>
      <mtx-datetimepicker
        #startDatetimePicker
        [type]="type"
        mode="portrait"
        timeInput
      ></mtx-datetimepicker>
      <input
        [mtxDatetimepicker]="startDatetimePicker"
        [formControlName]="controlName"
        [placeholder]="placeholder"
        matInput
      />
      <mtx-datetimepicker-toggle
        [for]="startDatetimePicker"
        matSuffix
      ></mtx-datetimepicker-toggle>
    </mat-form-field>
  }
  <div class="tw-text-xs"></div>
</div>
